var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0-141.4 114.6-256 256-256s256 114.6 256 256-114.6 256-256 256-256-114.6-256-256zm371.8-44.2c10.9-10.9 10.9-28.7 0-39.6s-28.7-10.9-39.6 0l-108.2 108.2-44.2-44.2c-10.9-10.9-28.7-10.9-39.6 0s-10.9 28.7 0 39.6l64 64c10.9 10.9 28.7 10.9 39.6 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.876ff4bf4b55f98d97269e0ec1a48796.svg";
export { ForwardRef as ReactComponent };